import { LoadCalculationResponse, RunCalculationPayload } from 'modules/af_tool/api/types';
import { Option, PageComponentProps } from 'shared/interface/globalInterface';
import { FormValues } from './partials/Form/Form.types';

export type InitialData = LoadCalculationResponse['initialData'];
export type FetchedResources = LoadCalculationResponse['resources'];
export type FetchedContext = LoadCalculationResponse['context'];
export type Payload = RunCalculationPayload;
export type Resources = { [key in keyof FetchedResources]: Option[] };
export type TFormValues = FormValues;
export type Props = PageComponentProps;
export type Context = {
  name: string;
  relatedCaseNumber: string;
  lastUpdated: string;
};

export type ExportTypes = 'csv';
export type ExportType = keyof ExportTypes;

export enum CREDIT_COMMITMENT_TYPES {
  CREDIT_CARD = 'CREDIT_CARD',
  UNSECURED_LOAN = 'UNSECURED_LOAN',
  MAINTENANCE_PAYMENTS = 'MAINTENANCE_PAYMENTS',
  STUDENT_LOAN = 'STUDENT_LOAN',
  BUY_TO_LET_MORTGAGE = 'BUY_TO_LET_MORTGAGE',
  PENSION_CONTRIBUTION = 'PENSION_CONTRIBUTION',
  OTHER = 'OTHER',
}
